import Client from './client.service';
import { cabane } from '@config/config';

class Cabane extends Client {
  static path = cabane;

  static url = (path) => {
    return this.api_url + this.api_url_prefix + path;
  };

  static get_cabane = async (page = 1, pagesize = 100, params = {}) => {
    const url = `${this.url(this.path.GET)}?${this._query_string({ cabane: 'cabane', page, pagesize, ...params })}`;
    return this._fetch(url);
  };
}

export default Cabane;
